import React, { useState, useEffect } from "react";
import Header from "../../../Components/Header";
import Seo from "../../../Components/SeoComponent/Seo";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import { fetchProfile } from "../../../Services/ApiTestService/aadharTestService";
import { verifyRcDetails } from "../../../Services/ApiTestService/apiTestService";
import { InputWithLabel, Button } from "../../../Components/Tags/Tags";
import Loader from "../../../Loader";
import { Link } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { useService } from "../../../context/ServiceContext";


const RcVerification = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [rcData, setRcData] = useState({});
  const [showRcData, setShowRcData] = useState(false)
  const [errors, setErrors] = useState({});
  const [profileData, setProfileData] = useState({});
  const [regNo, setRegNo] = useState("");
  const { serviceName } = useService();


  // Fetch profile data on mount
  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        setIsLoading(true);
        const response = await fetchProfile();
        setProfileData(response.data);
      } catch (error) {
        console.error("Error fetching profile data:", error);
        showErrorToast("Failed to fetch profile data.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchProfileData();
  }, []);


  const validateForm = (regNo) => {
    const errors = {};
    if (!regNo) {
      errors.regNo = "Registration No. is required.";
    }
    return errors;
  };



  const handleSubmit = async () => {
    const validationErrors = validateForm(regNo);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) return;

    try {
      setIsLoading(true);

      const response = await verifyRcDetails({
        api_id: profileData?.user_id,
        api_key: profileData?.api_key,
        token_id: profileData?.token_id,
        regNo: regNo,
      });

      const statusCode = response?.status?.code || response?.status;

      if (statusCode === 200) {

        const rcData = response?.data;  // <-- this is an ARRAY, perfect
        

        if (rcData) {
          setRcData(rcData); // <-- directly store the array
          setShowRcData(true);
          showSuccessToast(response.message, "Rc Details fetched successfully.");
          setRegNo("");
          setErrors({});
        } else {
          showErrorToast("Unexpected API format.");
        }
      }


      else if (statusCode === 422) {
        showErrorToast(response.data.message || "Invalid format");
      }

      else if (statusCode === 500) {
        showErrorToast(response.data.message || "Server error");
      }

      else {
        showErrorToast(response.status?.message || "Something went wrong");
      }

    } catch (error) {
      console.error("Rc To Mobile Error:", error);
      showErrorToast("Failed to verify Rc To Mobile.");
    } finally {
      setIsLoading(false);
    }
  };


  return (
    <>
      <Seo />
      {isLoading && <Loader />}
      <Header heading={serviceName} />

      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 justify-center md:ml-80 ml-0 p-4">
        <div className="col-span-2 md:col-span-6 flex justify-end">
          <Link
            to="/TestMaster"
            className="flex items-center gap-1 text-white bg-green-600 hover:bg-green-700 px-1 py-1 rounded-md font-semibold shadow-md transition duration-300"
          >
            <span>Go Back</span>
            <IoArrowBackCircleOutline size={24} />
          </Link>
        </div>

        <InputWithLabel
          type="text"
          label="Registration No."
          placeholder="Enter Registration No."
          className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
          name="regNo"
          id="regNo"
          required={true}
          value={regNo}
          onChange={(e) => setRegNo(e.target.value)}
          error={errors.pan}
        />

        <div>
          <Button
            type="button"
            className="text-center text-white bg-blue-900 shadow-lg bg-gradient-to-r from-blue-400 via-blue-1200 to-blue-900 font-semibold rounded-md px-2 py-1 mt-5 text-md hover:from-blue-900 hover:to-blue-400 border-4 ms-2"
            id="verifyRC"
            name="verifyRC"
            text="Verify"
            onClick={handleSubmit}
          />
        </div>
      </div>

      {/* instructions */}
      <div class="max-w-2xl mx-auto p-2 bg-white rounded-2xl shadow-lg mt-3 mb-6">
        <h2 class="text-xl font-bold text-center text-gray-800 mb-2">Rc Verification V3 Steps</h2>

        <ol class="list-decimal list-inside text-gray-700 space-y-1">
          <li>Enter your registration number.</li>
          <li>Click on "Verify" to check RC details.</li>
        </ol>

        <div class="mt-2">
          <h3 class="text-xl font-semibold text-gray-800 mb-2">Important Notes:</h3>
          <ul class="list-disc list-inside text-gray-600 space-y-1">
            <li>Do not refresh the page during the verification process.</li>
          </ul>
        </div>
      </div>

      {showRcData && rcData &&
        (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4 px-4">

            {/* Summary Card  */}
            <div className="bg-gradient-to-br from-blue-50 to-white border border-blue-200 rounded-2xl shadow-xl p-3 mzx-h-64 overflow-scroll">
              <h3 className="text-blue-800 font-semibold text-xl">Rc Data Summary</h3>
              <div className="text-sm text-gray-700 mt-2">
                <p><strong>Owner Name :</strong>{" "}{rcData.ownerName}</p>
                <p><strong>Father Name :</strong>{" "}{rcData.fatherName}</p>
                <p><strong>Status :</strong>{" "}{rcData.status}</p>
                <p><strong>Registration No :</strong>{" "}{rcData.regNo}</p>
                <p><strong>State :</strong>{" "}{rcData.state}</p>
                <p><strong>RTO :</strong>{" "}{rcData.rto}</p>
                <p><strong>Registration Date :</strong>{" "}{rcData.regDate}</p>
                <p><strong>Chassis No :</strong>{" "}{rcData.chassisNo}</p>
                <p><strong>Engine No :</strong>{" "}{rcData.engineNo}</p>
                <p><strong>Vehicle Class :</strong>{" "}{rcData.vehicleClass}</p>
                <p><strong>Vehicle Color :</strong>{" "}{rcData.vehicleColor}</p>
                <p><strong>Maker :</strong>{" "}{rcData.maker}</p>
                <p><strong>Maker Modal :</strong>{" "}{rcData.makerModal}</p>
                <p><strong>Body Type Desc :</strong>{" "}{rcData.bodyTypeDesc}</p>
                <p><strong>Fuel Type :</strong>{" "}{rcData.fuelType}</p>
                <p><strong>Fuel Norms :</strong>{" "}{rcData.fuelNorms}</p>
                <p><strong>Permanent Address :</strong>{" "}{rcData.permanentAddress}</p>
                <p><strong>Present Address :</strong>{" "}{rcData.presentAddress}</p>
                <p><strong>Fitness UpTo :</strong>{" "}{rcData.fitnessUpto}</p>
                <p><strong>Tax UpTo :</strong>{" "}{rcData.taxUpto}</p>
                <p><strong>Insurance Company :</strong>{" "}{rcData.insCompany}</p>
                <p><strong>Insurance Upto :</strong>{" "}{rcData.insUpto}</p>
                <p><strong>Policy No :</strong>{" "}{rcData.policyNo}</p>
                <p><strong>Puc No :</strong>{" "}{rcData.pucNo}</p>
                <p><strong>Puc Upto :</strong>{" "}{rcData.pucUpto}</p>
                <p><strong>Manufacture Month Year :</strong>{" "}{rcData.manufacturedMonthYear}</p>
                <p><strong>Unladen Weight :</strong>{" "}{rcData.unladenWeight}</p>
                <p><strong>No of Cylinders :</strong>{" "}{rcData.noCylinders}</p>
                <p><strong>Cubic Cap :</strong>{" "}{rcData.cubicCap}</p>
                <p><strong>No Of Seats :</strong>{" "}{rcData.noOfSeats}</p>
                <p><strong>Vechile Category :</strong>{" "}{rcData.vechileCategory}</p>
                <p><strong>RTO Code :</strong>{" "}{rcData.rtoCode}</p>
              </div>
            </div>  
       
            {/* JSON Preview */}
            <div className="bg-gradient-to-br from-blue-50 to-white border border-blue-200 rounded-2xl shadow-xl p-2">
              <h2 className="text-lg font-semibold text-blue-800 mb-1">Rc Details JSON Data</h2>
              <pre className="bg-gray-100 p-2 rounded text-sm overflow-y-auto max-h-[200px]">
                {JSON.stringify(rcData, null, 2)}
              </pre>
            </div>
          </div>
        )}
    </>
  );
};

export default RcVerification;
